import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import OperationsList from "../../components/Operations/OperationsList";
import { store } from "../../reducer/Store";
import OperationsTypeModal from "../../components/Operations/OperationsTypeModal";
import ApiService from "../../services/ApiService";
import { Spinner, Card, Alert } from "react-bootstrap";
export default function Operations() {
  const [show, setShow] = React.useState(false);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const { dispatch, state } = React.useContext(store);
  const [loader, setLoader] = React.useState(false);
  const [brand, setBrand] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [operationType, setOperationType] = React.useState({
    name: "",
    color: "",
    year_id: "",
    brand_id: "",
    media: null,
  });

  const [operationsDescriptions, setOperationsDescriptions] = React.useState([
    {
      name: "",
      operation_type_id: "",
    },
  ]);
  const [operationEdit, setOperationEdit] = React.useState({
    name: "",
    color: "",
    year_id: "",
    brand_id: "",
    media: null,
    operation_descriptions: [{ id: "", name: "", operation_type_id: "" }],
  });

  /**
   * Cette fonction gère l'ajout d'opérations et de descriptions d'opérations. 
   * Lorsque l'utilisateur soumet le formulaire, cette fonction est appelée.
   *  Elle empêche le comportement par défaut du formulaire, active le chargement, 
   * réinitialise le message d'erreur, puis effectue une requête API pour ajouter le type d'opération. Ensuite, 
   * elle vérifie si l'ajout du type d'opération a réussi et si des descriptions d'opérations sont présentes. Si c'est le cas, 
   * elle boucle à travers les descriptions d'opérations et effectue une requête API pour les ajouter une par une. Après avoir terminé l'ajout des descriptions d'opérations, 
   * elle ferme la fenêtre modale, réinitialise les valeurs du formulaire, récupère toutes les opérations types à jour, 
   * désactive le chargement et réinitialise les descriptions d'opérations. En cas d'erreur, 
   * elle affiche un message d'erreur approprié et désactive le chargement.
   * Gère l'ajout d'opérations et de descriptions d'opérations.
   * @param {*} e - L'événement de soumission du formulaire.
 */
  const handleAddOperations = async (e) => {
    e.preventDefault();
    setLoader(true);
    setErrorMessage("");

    //@@@ <

    const formData = new FormData(); 

    formData.append("name", operationType.name);
    formData.append("color", operationType.color);
    formData.append("brand_id", brand.value);
    formData.append("year_id", state.currentYear.value);

    // Ajout du Fichier (si un File Object est présent)
    if (operationType.media instanceof File) {
      formData.append("media", operationType.media); // 'media' est le File Object
    } else if (operationType.media) {
      // Si 'media' n'est pas un File mais une chaîne (URL existante en cas d'édition), on la conserve
      formData.append("media", operationType.media); 
    }

    //@@@ >

    await ApiService.request(
      //@@@ <
        /*
      {
        
        name: operationType.name,
        color: operationType.color,
        brand_id: brand.value,
        year_id: state.currentYear.value,
        media: operationType.media,
        
      },
      */

        //@@@ >
      formData, //@@@
      "operation-types",
      "post"
    )
      .then(function (response) {
        if (response.data.id) {
          const operationTypeId = response.data.id;
          const descriptionsWithOperationsId = operationsDescriptions.map(
            (description) => ({
              ...description,
              operation_type_id: operationTypeId,
            })
          );

          if (descriptionsWithOperationsId.length > 0) {
            descriptionsWithOperationsId.forEach(async (description) => {
              await ApiService.request(
                description,
                "operation-descriptions",
                "post"
              )
                .then((res) => {
                  // Récupère toutes les opérations types
                  getAllOperationsType();
                })
                .catch(() => {
                  setLoader(false);
                });
            });
          }
        }
        // Ferme la fenêtre modale
        setShow(false);
        // Réinitialise les valeurs
        setBrand([]);
        setOperationType({
          name: "",
          color: "",
          year_id: "",
          brand_id: "",
          media: null,
        });
        getAllOperationsType();
        setLoader(false);
        setOperationsDescriptions([]);
      })
      .catch(function (error) {
        const errorMessageFromServer = 
            error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Erreur inconnue lors de la mise à jour.';
        
        if (errorMessageFromServer.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà.");
        } else if (error.response?.data?.errors) {
          // Affiche l'erreur de validation si elle est détaillée par Laravel
          setErrorMessage("Erreur de validation. Veuillez vérifier les champs.");
          console.error("Détails Validation:", error.response.data.errors);
        } else {
          setErrorMessage(errorMessageFromServer);
        }
        
        console.log(error); // Laissez le log complet de l'erreur Axios
        setLoader(false);
        /*
        // manque un message quand c'est une error
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà.");
        }
        console.log(error);
        setLoader(false);
        */
      });
  };

  /**
 * Gère la mise à jour d'une opération type.
 * Cette fonction gère la mise à jour d'une opération type. 
 * Lorsqu'elle est appelée, elle vérifie si l'opération type est utilisée par des clients.
 *  Si c'est le cas, elle affiche une confirmation à l'utilisateur avant de procéder à la mise à jour, car cela affectera également les opérations des clients. 
 * Ensuite, elle effectue une requête API de mise à jour de l'opération type avec les nouvelles valeurs. 
 * Si une marque spécifique n'est pas sélectionnée, elle met à jour la liste des marques en fonction de l'identifiant de marque de l'opération type. 
 * Ensuite, elle gère les descriptions d'opération associées à l'opération type.
 *  Si des descriptions existent, elle effectue les requêtes de mise à jour ou d'ajout nécessaires pour chaque description.
 *  Enfin, elle désactive le chargement, ferme la fenêtre modale de mise à jour et récupère toutes les opérations types.
 * @param {*} e - L'événement de soumission du formulaire.
 */
  const handleUpdateOperation = async (e) => {
    setLoader(true);
    setErrorMessage("");
    e.preventDefault();
    var validateUpdateOpeType = true;
    // Vérifie si l'opération type est utilisée par des clients
    if (
      state.operationsType.filter((elt) => elt.id === operationEdit.id)[0]
        .operations.length > 0
    ) {
      if (
        window.confirm(
          "Cette opération type est utilisée sur des clients, si vous la modifiez, vous modifierez aussi leurs opérations. Êtes-vous sûr de poursuivre ?"
        )
      ) {
        validateUpdateOpeType = true;
      } else {
        validateUpdateOpeType = false;
      }
    }
    if (validateUpdateOpeType) {
      if (undefined === brand.value) {
        var tab = [];
        state.listBrands.filter((brand) =>
          brand.value === operationEdit.brand_id.toString()
            ? tab.push(brand)
            : ""
        );
        setBrand(tab);
      }

      //@@@ <
      const formData = new FormData();
      formData.append("name", operationEdit.name);
      formData.append("color", operationEdit.color);
      formData.append("brand_id", operationEdit.brand_id);
      formData.append("year_id", state.currentYear.value);

      formData.append("_method", "PUT"); 

      // Gestion de l'image (media)
      if (operationEdit.media instanceof File) {
          // Nouveau fichier binaire sélectionné
          formData.append("media", operationEdit.media); 
      } else if (operationEdit.media === null) {
          // Le média a été supprimé (valeur null envoyée pour le backend)
          formData.append("media", ''); 
      } 

      //@@@ >

      // Effectue la requête de mise à jour de l'opération type
      await ApiService.request(
        //@@@ < 
        /*
        {
          name: operationEdit.name,
          color: operationEdit.color,
          brand_id: operationEdit.brand_id,
          year_id: state.currentYear.value,
          media: operationEdit.media,
        },
        */
        //@@@ >
        formData, //@@@
        "operation-types/" + operationEdit.id,
        "post" //@@@
      )
        .then(function () {
          setLoader(false);
          handleCloseUpdate();
          getAllOperationsType();
        })
        .catch(function (error) {
          if (error.response.data.message.includes("already exists")) {
            setErrorMessage("Ce nom existe déjà.");
          }
          console.log(error);
          setLoader(false);
        });
      if (
        operationEdit.operation_descriptions &&
        operationEdit.operation_descriptions.length > 0
      ) {
        operationEdit.operation_descriptions.forEach(async (description) => {
          const descriptions = description;
          const { id, ...data } = descriptions;
          if (description.id) {

            // Effectue la requête de mise à jour de la description d'opération existante
            await ApiService.request(
              data,
              "operation-descriptions/" + description.id,
              "put"
            )
              .then((res) => {
                /*    console.log(res, "resss"); */
                getAllOperationsType();
                setLoader(false);
              })
              .catch(() => {
                setLoader(false);
              });
          } else {
            // Effectue la requête d'ajout d'une nouvelle description d'opération
            await ApiService.request(
              {
                name: description.name,
                operation_type_id: operationEdit.id,
              },
              "operation-descriptions",
              "post"
            )
              .then((res) => {
                getAllOperationsType();
                handleCloseUpdate();
                setLoader(false);
              })
              .catch(() => {
                setLoader(false);
              });
          }
        });
      }
    }
  };
  /**
   * update each items  operations list except offersDescription
   * @param {*} field
   * @returns void
   */
  //@@@ <
  /*
  const handleOperationsChange = (e, field) => {
    setOperationType((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };
  */
 const handleOperationsChange = (eOrValue, field) => { // Accepte un événement OU une valeur directe
  let value = eOrValue;

  if (field !== 'media' && eOrValue && eOrValue.target) {
      value = eOrValue.target.value;
  }

  setOperationType((prev) => ({
    ...prev,
    [field]: value, // Stocke l'objet File ou la chaîne URL
  }));
};

  //@@@ >
  /**
   * Lors de la modification de l'opération
   * update each items  operations list except offersDescription
   * @param {*} field
   * @returns void
   */
  //@@@ <
  /*
  const handleOperationsChangeUpdate = (e, field) => {
    setOperationEdit((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };
  */
 const handleOperationsChangeUpdate = (eOrValue, field) => { 
  let value = eOrValue;

  if (field !== 'media' && eOrValue && eOrValue.target) {
      value = eOrValue.target.value;
  }
  
  setOperationEdit((prev) => ({
    ...prev,
    [field]: value,
  }));
};
  //@@@ >
  /**
   *
   * @param {*} field the name of the element to edit
   * @param {*} i  is the index of curent element offersDescription array
   * @returns void
   */

  const handleOffersDescriptionChange = (event, index) => {
    const { value } = event.target;
    setOperationsDescriptions((prevDescriptions) =>
      prevDescriptions.map((description, i) =>
        i === index ? { ...description, name: value } : description
      )
    );
  };

  const handleOffersDescriptionChangeUpdate = (event, index) => {
    const { value } = event.target;
    setOperationEdit((prevState) => ({
      ...prevState,
      operation_descriptions: prevState.operation_descriptions.map(
        (opedescription, i) =>
          i === index ? { ...opedescription, name: value } : opedescription
      ),
    }));
  };
  /**
   * Fetch all operations
   */
  const getAllOperationsType = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    setLoader(true);
    ApiService.request(
      {},
      `operation-types-by-brands-year/${brands}/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        setLoader(false);
        //console.log(response.data, "operations");
        const operationsType = response.data;
        dispatch({ type: "SET_OPERATIONSTYPE", payload: operationsType });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        /*  console.log(error);*/
        setLoader(false);
      });
  };

  /**
   * This function updates the state by creating a new array newOffersDescription based
   * on the current operations.offersDescription array and adding a new empty string to the end of the array.
   *  Finally, it uses the setOperations hook to update the state with the new newOffersDescription array.
   *
   */
  const handleAddOfferDescription = () => {
    setOperationsDescriptions([
      ...operationsDescriptions,
      { name: "", operation_type_id: "" },
    ]);
  };
  /**
 * Ajoute une nouvelle description d'opération à la liste des descriptions d'opération lors de la mise à jour d'une offre.
 * Cette fonction permet d'ajouter une nouvelle description d'opération à la liste des descriptions d'opération lors de la mise à jour d'une offre. 
 * Lorsqu'elle est appelée, elle utilise le state operationEdit et utilise la fonction setOperationEdit pour ajouter une nouvelle description d'opération vide à la liste existante. 
 * Cela permet de permettre à l'utilisateur d'ajouter une nouvelle description d'opération lors de la mise à jour de l'offre.
 */
  const handleAddOfferDescriptionUpdate = () => {
    setOperationEdit((prevState) => ({
      ...prevState,
      operation_descriptions: [
        ...prevState.operation_descriptions,
        { name: "", operation_type_id: "" },
      ],
    }));
  };
  /**
   * This function updates the state by creating a new array newOffersDescription based on the current
   * OperationsDescriptions array and filtering out the element at the index i. Finally,
   * it uses the setOperations hook to update the state with the new newOffersDescription array.
   * @param {*} i
   * @returns
   */
  const handleDeleteOfferDescription = (index) => {
    setOperationsDescriptions((prevDescriptions) =>
      prevDescriptions.filter((description, i) => i !== index)
    );
  };
  const deleteOperationsType = (opeId) => {
    var message = "";
    message =
      state.operationsType.filter((elt) => elt.id === opeId)[0].operations
        .length > 0
        ? "Cette opération type est utilisée sur des clients, si vous la supprimez, vous supprimerez aussi leurs opérations. Êtes-vous sûr ? Cela est définitif."
        : "Êtes-vous sûr de vouloir supprimer cette opération type ? Cela est définitif.";
    if (window.confirm(message)) {
      ApiService.request({}, "operation-types/" + opeId, "delete")
        .then(function () {
          setLoader(false);
          getAllOperationsType();
        })
        .catch(function (error) {
          setLoader(false);
          console.log(error);
        });
    }
  };
  /**
 * Gère la suppression d'une description d'opération lors de la mise à jour d'une offre.
 * Cette fonction gère la suppression d'une description d'opération lors de la mise à jour d'une offre. Lorsqu'elle est appelée, 
 * elle vérifie si la description d'opération a un ID. Si c'est le cas, elle affiche une confirmation à l'utilisateur avant de procéder à la suppression définitive de la description d'opération en effectuant une requête API de suppression. 
 * Ensuite, elle désactive le chargement, récupère toutes les opérations types, ferme la fenêtre modale de mise à jour et réinitialise les marques. 
 * Si la description d'opération n'a pas d'ID, elle supprime simplement l'élément correspondant de la liste des descriptions d'opération dans le state operationEdit.
 * @param {*} opeType - L'objet description d'opération à supprimer.
 * @param {*} i - L'index de l'élément à supprimer dans la liste des descriptions d'opération.
 */
  const handleDeleteOfferDescriptioUpdate = (ope, i) => {
    if (ope.id) {
      if (
        window.confirm(
          "Voulez vous vraiment supprimer cette description de l'opération ? Cela est définitif."
        )
      ) {
        setLoader(true);
        ApiService.request({}, "operation-descriptions/" + ope.id, "delete")
          .then(function () {
            setLoader(false);
            getAllOperationsType();
            handleCloseUpdate();
            setBrand([]);
          })
          .catch(function (error) {
            setLoader(false);
            console.log(error);
          });
      }
    } else {
      if (
        window.confirm(
          "Voulez vous vraiment supprimer cette description de l'opération ? Cela est définitif."
        )
      ) {
        setOperationEdit((prevState) => ({
          ...prevState,
          operation_descriptions: prevState.operation_descriptions.filter(
            (item, index) => index !== i
          ),
        }));
      }
    }
  };

  /**
   * Handle display of modal add or edit operation-type
   * @returns
   */
  const handleClose = () => {
    setShow(false);
    setBrand([]);
    setOperationType({
      name: "",
      color: "",
      year_id: "",
      brand_id: "",
      media: null,
    });
    setOperationsDescriptions([
      {
        name: "",
        operation_type_id: "",
      },
    ]);
    setErrorMessage("");
  };
  const handleShow = () => setShow(true);
  /**
 * Gère l'affichage de la fenêtre modale de mise à jour d'une opération type.
 * Cette fonction gère l'affichage de la fenêtre modale de mise à jour d'une opération type. 
 * Lorsqu'elle est appelée, elle prend en paramètre l'objet opeType qui représente l'opération type à mettre à jour.
 *  Elle utilise cet objet pour initialiser les valeurs de l'état operationEdit qui sera utilisé pour pré-remplir les champs de la fenêtre modale de mise à jour. 
 * Elle copie également les descriptions d'opération associées à l'opération type dans l'état operationEdit.
 *  Ensuite, elle filtre la liste des marques disponibles pour récupérer la marque correspondant à l'identifiant de marque de l'opération type, et met à jour l'état brand avec cette marque.
 *  Enfin, elle définit l'état showUpdate à true, ce qui provoque l'affichage de la fenêtre modale de mise à jour.
 * @param {Object} opeType - L'objet représentant l'opération type à mettre à jour.
 * 
 */
  const handleShowUpdate = (opeType) => {
    // console.log(opeType);

    setOperationEdit({
      id: opeType.id,
      name: opeType.name,
      color: opeType.color,
      year_id: opeType.year.id,
      brand_id: opeType.brand_id,
      media: opeType.media || null,
      operation_descriptions: [...opeType.operation_descriptions],
    });

    var tab = [];
    state.listBrands.filter((brand) =>
      brand.value === opeType.brand_id.toString() ? tab.push(brand) : ""
    );

    setBrand(tab);
    setShowUpdate(true);
  };
  const handleCloseUpdate = () => {
    setShow(false);
    setShowUpdate(false);
    setErrorMessage("");
    setBrand([]);
    setOperationType({
      name: "",
      color: "",
      year_id: "",
      brand_id: "",
      media: null,
    });
    setOperationsDescriptions([]);
  };
  React.useEffect(() => {
    if (state.currentBrands.length > 0) {
      getAllOperationsType();
    } else {
      dispatch({ type: "SET_OPERATIONSTYPE", payload: [] });
    }
  }, [state.currentYear, state.currentBrands]);

  return (
    <>
      <h1>
        Operations
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                if (state.currentBrands.length === 1) {
                  setBrand(state.currentBrands[0]);
                }
                handleShow();
              }}
              disabled={state.currentBrands.length === 0 ? true : false}
            >
              <AddCircleOutlineOutlinedIcon /> Ajouter
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>
      {show && (
        <OperationsTypeModal
          show={show}
          handleClose={handleClose}
          handleShow={handleClose}
          action={"Ajouter Opération"}
          handleAddOperations={handleAddOperations}
          operationsType={operationType}
          handleOperationsChange={handleOperationsChange}
          handleOffersDescriptionChange={handleOffersDescriptionChange}
          handleDeleteOfferDescription={handleDeleteOfferDescription}
          handleAddOfferDescription={handleAddOfferDescription}
          setBrand={setBrand}
          valueBrand={brand}
          brandList={state.currentBrands}
          errorMessage={errorMessage}
          operationsDescriptions={operationsDescriptions}
        />
      )}

      {showUpdate && (
        <OperationsTypeModal
          show={showUpdate}
          handleClose={handleCloseUpdate}
          action={"Modifier Opération"}
          handleAddOperations={handleUpdateOperation}
          operationsType={operationEdit}
          handleOperationsChange={handleOperationsChangeUpdate}
          handleOffersDescriptionChange={handleOffersDescriptionChangeUpdate}
          handleDeleteOfferDescription={handleDeleteOfferDescriptioUpdate}
          handleAddOfferDescription={handleAddOfferDescriptionUpdate}
          valueBrand={brand}
          setBrand={setBrand}
          errorMessage={errorMessage}
          brandList={state.listBrands.slice(1)}
        />
      )}
      {state.currentBrands.length > 0 ? (
        <>
          {!loader ? (
            state.operationsType.length > 0 ? (
              state.operationsType.map((opeType, i) => (
                <OperationsList
                  key={i}
                  operationType={opeType}
                  deleteOperationsType={deleteOperationsType}
                  handleShowUpdate={handleShowUpdate}
                />
              ))
            ) : (
              <Card className="text-center">
                <Card.Body>
                  <Alert variant="info" className="m-0">
                    La liste est vide.
                  </Alert>
                </Card.Body>
              </Card>
            )
          ) : (
            <div className="text-center pt-5">
              <Spinner
                animation={loader ? "border" : false}
                role="status"
              ></Spinner>
            </div>
          )}
        </>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
}
